import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';

const NavLinks = () => {
  
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const dashboardPaths = ['/admin/dashboard'];
  const createEventPaths = ['/admin/create-event'];

  const isPathInCategory = (pathsArray) => {
    return pathsArray.some(path => currentPath === path);
  };

  // Logout handler
  const handleLogout = () => {
    // Hapus token atau session di sini
    // localStorage.removeItem('token'); // atau sessionStorage, tergantung implementasi kamu

    logout();
    // Arahkan ke halaman login
    navigate('/login');
  };

  return (
    <ul className="navbar-nav pt-lg-3">

      {/* Profile */}
      <li className="nav-item">
        <Link
          className={`nav-link${isPathInCategory(dashboardPaths) ? ' active' : ''}`}
          to="/peserta/profile"
        >
          <span className="nav-link-icon d-md-none d-lg-inline-block">
            <i className="bi bi-person-circle"></i>
          </span>
          <span className="nav-link-title">Profile</span>
        </Link>
      </li>

      {/* Info Event */}
      <li className="nav-item">
        <Link
          className={`nav-link${isPathInCategory(createEventPaths) ? ' active' : ''}`}
          to="/peserta/info-event"
        >
          <span className="nav-link-icon d-md-none d-lg-inline-block">
            <i className="bi bi-calendar-event-fill"></i>
          </span>
          <span className="nav-link-title">Info Event</span>
        </Link>
      </li>

      {/* Upload Bukti Pembayaran */}
      <li className="nav-item">
        <Link
          className={`nav-link${isPathInCategory(createEventPaths) ? ' active' : ''}`}
          to="/peserta/upload-pembayaran"
        >
          <span className="nav-link-icon d-md-none d-lg-inline-block">
            <i className="bi bi-upload"></i>
          </span>
          <span className="nav-link-title">Upload Bukti Pembayaran</span>
        </Link>
      </li>

      {/* Logout */}
      <li className="nav-item">
        <button
          className="nav-link w-100 text-start bg-transparent border-0"
          onClick={handleLogout}
        >
          <span className="nav-link-icon d-md-none d-lg-inline-block">
            <i className="bi bi-box-arrow-right"></i>
          </span>
          <span className="nav-link-title">Logout</span>
        </button>
      </li>

    </ul>
  );
};

export default NavLinks;
